export default __webpack_public_path__ + "static/media/semsPlusPlus_zh.e0995817.png";